import { render, staticRenderFns } from "./DescriptionProduct.vue?vue&type=template&id=3c91b3b0"
import script from "./DescriptionProduct.vue?vue&type=script&lang=js"
export * from "./DescriptionProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports